angular.module("dx.webapp.student", [
	"dx.webapp.answer",
	"dx.webapp.navigation",
	"dx.webapp.sorting",
	"dx.webapp.user",
	"dx.webapp.roles",
	"digiexam.services",

	"dx.ui.utils",
	"dx.ui.components.localize",
]);
